serviceForm.$inject = ['$rootScope', 'ServiceService', 'AppService', '$timeout', '$uibModal']

export default function serviceForm($rootScope, ServiceService, AppService, $timeout, $uibModal) {
  var directive = {
    restrict: 'E',
    replace: true,
    scope: {
      service: '=',
      currency: '='
    },
    link: function(scope, elem, attrs) {
      scope.$parent[attrs.property] = this
      this.isPristine = () => scope.serviceForm.$pristine

      scope.filePath = $rootScope.filePath
      AppService.getMediaPlacements().then(res => scope.mediaPlacements = res.data)
      AppService.getPaymentTypes().then(res => scope.paymentTypes = res.data)
      ServiceService.getServices(sessionStorage.getItem('profileId')).then(res => scope.services = res.data)
      ServiceService.getServiceCategories(sessionStorage.getItem('profileId')).then(res => scope.serviceCategories = res.data)

      scope.uploadMedias = function(files, placement, invalidFiles) {
        files.forEach((file, index) => {
          scope.uploadedFile = true
          $rootScope.$on('uploadProgress', (event, data) => scope.uploadProgress = data)

          AppService.uploadMedia(file).then(res => {
            var file = res.data

            scope.uploadProgress = 100.0
            $timeout(function() {
              scope.hideAlert('uploadedFile')
            }, 5000)

            if (!scope.service.medias) scope.service.medias = new Array()

            var media, originalMedia
            new Promise((resolve, reject) => {
              if (file.type.includes('video')) {
                AppService.getMediaById(file.attrs.mediaId).then(res => {
                  originalMedia = file
                  media = res.data
                  resolve()
                })
              } else {
                media = file
                resolve()
              }
            }).then(() => {
              var existingServiceToMediasSamePlacement = scope.service.medias.filter(media => media.mediaPlacement.placement.toLowerCase() == placement)
              var mediaPlacement = scope.mediaPlacements.find(mediaPlacement => mediaPlacement.placement.toLowerCase() == placement)
              var newServiceToMediaSamePlacement = {
                order: existingServiceToMediasSamePlacement.length + 1,
                mediaId: file.id,
                mediaPlacementId: mediaPlacement.id,
                media: media,
                mediaPlacement: mediaPlacement
              }
              if (originalMedia) newServiceToMediaSamePlacement.originalMedia = originalMedia
              scope.service.medias.push(newServiceToMediaSamePlacement)
              if (existingServiceToMediasSamePlacement.length === 1 && existingServiceToMediasSamePlacement[0].mediaPlacement.isReplace) {
                var index = scope.service.medias.findIndex(media => media === existingServiceToMediasSamePlacement[0], 1)
                scope.service.medias.splice(index, 1)
                newServiceToMediaSamePlacement.order = newServiceToMediaSamePlacement.order - 1
              }
            })
          })
        })
        invalidFiles.forEach((file, index) => {
          scope.invalidFile = true
          scope.file = file
          $timeout(function() {
            scope.hideAlert('invalidFile')
          }, 5000)
        })
      }
      scope.addExternalResource = function() {
        $uibModal.open({
          controller: 'ModalExternalResourceController',
          controllerAs: 'modalExternalResource',
          template: require('../../app/external-resource-modal-new.html')
        }).result.then(externalResource => {
          if (externalResource) {
            scope.service.externalResources.push(externalResource)
          }
        })
      }
      scope.removeMedia = function(media) {
        var index = scope.service.medias.findIndex(media2 => media2.id === media.id)
        scope.service.medias.splice(index, 1)
      }
      scope.hideAlert = function(alert) {
        scope[alert] = false
      }
    },
    template: require('./_form-service.html')
  }

  return directive
}